import { productHighlights } from "@/mocks/home";

export default function Features() {
  return (
    <section id="features" className="w-full bg-background-100 py-14 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 md:mb-14">
          <div>
            <span className="inline-block font-heading tracking-[0.32em] text-xs font-semibold text-primary-600">
              CORE FEATURES
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
              라이더가 필요한<br />6가지 감각을 담다
            </h2>
          </div>
          <p className="max-w-md text-foreground-700 text-base leading-relaxed">
            소리, 연결, 안전, 지속력. X9 PRO는 라이딩의 모든 순간을 위해
            치밀하게 설계되었습니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {productHighlights.map((f, idx) => (
            <div
              key={f.id}
              className={`rounded-xl p-7 md:p-8 border transition-all duration-300 hover:-translate-y-1 ${
                idx === 0
                  ? "bg-primary-500 text-background-50 border-primary-500"
                  : idx === 3
                  ? "bg-accent-500 text-background-50 border-accent-500"
                  : "bg-background-50 border-background-200/70 text-foreground-950"
              }`}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-lg text-xl ${
                  idx === 0
                    ? "bg-background-50/20 text-background-50"
                    : idx === 3
                    ? "bg-background-50/20 text-background-50"
                    : "bg-secondary-100 text-secondary-900"
                }`}
              >
                <i className={f.icon}></i>
              </div>
              <div
                className={`mt-6 font-heading text-[11px] tracking-[0.3em] font-semibold ${
                  idx === 0 || idx === 3 ? "text-background-100" : "text-foreground-500"
                }`}
              >
                {f.tag}
              </div>
              <h3
                className={`mt-2 font-heading text-xl md:text-2xl font-bold leading-tight ${
                  idx === 0 || idx === 3 ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {f.title}
              </h3>
              <p
                className={`mt-3 text-sm leading-relaxed ${
                  idx === 0 || idx === 3 ? "text-background-100/90" : "text-foreground-700"
                }`}
              >
                {f.body}
              </p>
              {f.bullets && (
                <ul className={`mt-5 pt-5 border-t ${idx === 0 || idx === 3 ? 'border-background-50/20' : 'border-background-200/50'} space-y-2`}>
                  {f.bullets.map((b) => (
                    <li key={b} className={`flex items-center gap-2 text-xs ${idx === 0 || idx === 3 ? 'text-background-100/80' : 'text-foreground-600'}`}>
                      <span className={`w-1 h-1 rounded-full ${idx === 0 || idx === 3 ? 'bg-background-50' : 'bg-secondary-500'}`}></span>
                      {b}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}